
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import SubcatchmentMap from './SubcatchmentMap';
import { LineChart } from './LineChart';
import {RegionChart} from './Charts/TimeseriesChart';
import ContainerDimensions from 'react-container-dimensions';
import Gauges from './Gauges';
import Card from './Card';

import {getTransparentColor} from "./styles";

const mapStyle = {
  'backgroundColor': '#fff',
  'border': '1px solid',
  'borderColor': 'rgba(0,0,0,.0625)',
  'height': '440px',
};

export class Home extends Component {
  constructor() {
    super();
    this.state = { selectedCatchmentName: '' };
    this.getLineData = this.getLineData.bind(this);
  }
  
  async componentDidMount() {
    const response = await fetch(`/api/boundary/CatchmentNameDictionary`);
    const nameDictionary = await response.json();
    this.setState({catchmentNameDictionary : nameDictionary});
  }
  
  getLineData() {
    if (this.state.rainfall)
      return [this.state.rainfall, this.state.pet];
    return [];
  }

  selectionChanged(feature) {
    let id = feature.properties.SCID;
    const name = this.state.catchmentNameDictionary[id] || id;
    fetch(`api/seriesdata/gethistoricvalues/${id}`)
        .then(response => response.json())
        .then(data => {
          this.setState({ selectedCatchmentId: id, selectedCatchmentName: name, rainfall: data.rainfall, pet: data.pet, spei: data.spei });
        });
  }
  
  displayName = Home.name;
  
  regionOpacity = 20;
  regions = [
      { min: 0, max: 3, color: getTransparentColor('green', this.regionOpacity), fill: 'tozeroy', name: 'Not in Drought'},
      { max: -1.0, color: getTransparentColor('yellow', this.regionOpacity), fill: 'tozeroy', name: 'Mild Drought'},
      { max: -1.5, color: getTransparentColor('orange', this.regionOpacity), fill: 'tonexty', name: 'Moderate Drought'},
      { max: -3, color: getTransparentColor('red', this.regionOpacity), fill:'tonexty', name: 'Severe Drought'},
  ];
  render() {
      const speiData = this.state.spei ? [this.state.spei] : [];
    return (
      <div>
        <Row>
          <Col sm={8} style={mapStyle}>
            <ContainerDimensions>
              <SubcatchmentMap click={this.selectionChanged.bind(this)} />
            </ContainerDimensions>
          </Col>
          <Col sm={4} style={{ backgroundColor: 'white' }}>
            <Gauges catchmentName={this.state.selectedCatchmentName} catchmentId={this.state.selectedCatchmentId} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <LineChart title={`Monthly Climate data`} series={this.getLineData()} />
            </Card>
          </Col>
        </Row>
          <Row>
              <Col>
                  <Card>
                      <RegionChart title={'SPEI chart'} series={speiData} regions={this.regions}/>
                  </Card>
              </Col>
          </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Home.jsx